module.exports = __webpack_public_path__ + "static/media/discussion-icon.7428b308.svg";